import React, { useState, useEffect } from "react";
import { Col, Card, CardBody, Form, Label, Row } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { useForm } from "react-hook-form";
import { Save } from "../../../Constant";
import {
  addTaluk,
  addTalukRole,
  updateTaluk,
  updateTalukRole,
} from "../../../CommonUrl";
import { postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from "react-toastify";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Popup from "../../Common/Popup/popup";
import { useSelector } from "react-redux";

const schema = yup.object().shape({
  name: yup.string().required("Taluk name is required").label("Taluk Name"),
});

function AddEditTalukModal({ modal, handleModal, editData, refreshList }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [loading, setLoading] = useState(false);
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    if (modal) {
      if (editData) {
        reset({
          name: editData.name || "",
        });
      } else {
        reset({ name: "" });
      }
    }
  }, [editData, modal, reset]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      if (editData) {
        // Edit Mode
        const endpoint = authState.userRole === 1 ? updateTaluk : updateTalukRole;
        const talukId = editData.id || editData.taluk_id;
        const payload = {
          taluk_id: talukId,
          name: data.name,
        };
        const result = await postClientUrlWithToken(authState.apiUrl, endpoint, payload);
        if (result?.status === 200) {
          if (result?.data?.status === true) {
            toast.success(result?.data?.message || "Taluk updated successfully!");
            handleModal();
            reset();
            refreshList();
          } else {
            toast.error(result?.data?.message || "Failed to update taluk");
          }
        } else {
          toast.error(result?.data?.message || "Failed to update taluk");
        }
      } else {
        // Add Mode
        const endpoint = authState.userRole === 1 ? addTaluk : addTalukRole;
        const payload = {
          name: data.name,
        };
        const result = await postClientUrlWithToken(authState.apiUrl, endpoint, payload);
        if (result?.status === 200) {
          if (result?.data?.status === true) {
            toast.success(result?.data?.message || "Taluk created successfully!");
            handleModal();
            reset();
            refreshList(result?.data?.data || { name: data.name });
          } else {
            toast.error(result?.data?.message || "Failed to create taluk");
          }
        } else {
          toast.error(result?.data?.message || "Failed to create taluk");
        }
      }
    } catch (err) {
      console.error("Error saving taluk:", err);
      toast.error("An error occurred while saving taluk");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popup
      title={editData ? "Edit Taluk" : "Add Taluk"}
      isOpen={modal}
      toggler={handleModal}
      size="md"
    >
      <>
        {loading && <Transparentspinner />}
        <Card className="border-0 shadow-none mb-0">
          <CardBody className="p-3">
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
              <Row className="g-3">
                <Col md="12">
                  <Label className="form-label fw-bold" htmlFor="taluk_name">
                    Taluk Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className="form-control"
                    id="taluk_name"
                    type="text"
                    placeholder="Enter taluk name"
                    {...register("name")}
                  />
                  {errors?.name && (
                    <span className="text-danger small mt-1 d-block">
                      {errors?.name?.message}
                    </span>
                  )}
                </Col>
              </Row>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <Btn attrBtn={{ color: "light", type: "button", onClick: handleModal }}>
                  Cancel
                </Btn>
                <Btn attrBtn={{ color: "primary", type: "submit" }}>
                  {Save}
                </Btn>
              </div>
            </Form>
          </CardBody>
        </Card>
      </>
    </Popup>
  );
}

export default AddEditTalukModal;
